// Kept free of fetcher imports so retry policies (useWalletAssets) and the
// global query error filter (context/utils.ts) can depend on it without
// pulling in the SDK-heavy fetcher modules.

// The wallet asset list could not be completed (pagination cap reached or the
// validator repeated a cursor). Deterministic for a given server state, so
// callers must not retry — each attempt re-crawls every page.
export class WalletAssetsIncompleteError extends Error {}
